import React, { useRef, useEffect } from 'react';
import RichTextToolbar from './RichTextToolbar';

const RichTextEditor = ({ value, onChange, placeholder = 'Type your content here...' }) => {
  const contentRef = useRef(null);

  // Initialize content
  useEffect(() => {
    if (contentRef.current && contentRef.current.innerHTML !== value) {
      contentRef.current.innerHTML = value || '';
    }
  }, [value]);

  const handleInput = () => {
    if (contentRef.current && onChange) {
      onChange(contentRef.current.innerHTML);
    }
  };

  return (
    <div className="rich-text-editor-wrapper border-2 border-blue-300 rounded-lg overflow-hidden bg-white shadow-sm">
      <div className="bg-blue-50 px-4 py-2 border-b border-blue-200">
        <p className="text-sm font-semibold text-blue-900">Content Editor - Type or paste your courseware</p>
      </div>
      
      {/* Rich Text Toolbar */}
      <div className="border-b border-gray-200 bg-gray-50">
        <RichTextToolbar targetRef={contentRef} />
      </div>
      
      {/* Editable Content Area */}
      <div
        ref={contentRef}
        contentEditable={true}
        suppressContentEditableWarning={true}
        onInput={handleInput}
        className="w-full p-6 focus:outline-none focus:ring-2 focus:ring-blue-500 text-base prose prose-lg max-w-none"
        style={{ minHeight: '300px', lineHeight: '1.8', fontFamily: 'system-ui, -apple-system, sans-serif' }}
        data-placeholder={placeholder}
      />
      
      <div className="bg-gray-50 px-4 py-2 border-t border-gray-200">
        <p className="text-xs text-gray-600">💡 Tip: You can paste formatted content and use HTML tags for styling</p>
      </div>
    </div>
  );
};

export default RichTextEditor;
